import type { ReactElement } from "react"
import SurfaceOrg from "@onestore/hel/dist/components/organisms/SurfaceOrg"
import OnColorContext from "@onestore/hel/dist/contexts/OnColorContext"
import BaseContainer from "@gatsby-plugin-generic-page/components/BaseContainer"
import BaseSection from "@gatsby-plugin-generic-page/components/BaseSection"
import Header from "@gatsby-plugin-generic-page/components/Header"
import type { ProductCardsGridSectionFlatData } from "@gatsby-plugin-generic-page/fragments/productCardsGridSection"
import getBackground from "@gatsby-plugin-generic-page/helpers/getBackground"
import isEmpty from "~/lib/isEmpty"
import ProductCard from "./components/ProductCard"

export default function ProductCardsGridSection({
  header,
  containerBackgroundColor,
  cards,
  sectionSettings,
}: ProductCardsGridSectionFlatData): ReactElement<ProductCardsGridSectionFlatData> {
  const { backgroundThemeColor, customColor, customOnColorText } =
    getBackground(containerBackgroundColor)

  const contentElement = (
    <>
      {!isEmpty(header) ? (
        <div className="mb-4 lg:mb-7">
          <Header {...header} />
        </div>
      ) : null}

      <OnColorContext.Provider value="backgroundLight">
        <div
          className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-${cards.length} gap-3 md:gap-4 lg:gap-3 items-stretch`}
        >
          {cards.map((card, index) => (
            <div className={index === 0 ? "md:col-span-2 lg:col-span-1" : ""}>
              <ProductCard {...card} isTabletFullVariant={index === 0} />
            </div>
          ))}
        </div>
      </OnColorContext.Provider>
    </>
  )

  return (
    <BaseSection {...sectionSettings}>
      <BaseContainer {...sectionSettings?.containerSettings}>
        {!isEmpty(containerBackgroundColor) ? (
          <SurfaceOrg
            spacingSpace={4}
            customColor={customColor?.background}
            color={backgroundThemeColor || customOnColorText}
            borderRadiusSize="none"
          >
            {contentElement}
          </SurfaceOrg>
        ) : (
          contentElement
        )}
      </BaseContainer>
    </BaseSection>
  )
}
